import FetchRailRodPrice from "./FetchRailRodPrice";
import {_} from "vue-underscore";

export const FetchRailRod = {
  mixins: [FetchRailRodPrice],
  created() {
    this.debouncedFetchRailRodPriceData = _.debounce(
      () => this.fetchRailRodPriceData(), 500
    )
  },
  watch: {
    railRodParameters() { this.debouncedFetchRailRodPriceData() },
  },
}
